import Service from "./Service"

/** Base URL for secure prestation retro endpoint (catalog-manager-secure). */
const CATALOG_MANAGER_SECURE_URL = "https://api.travelski.com/catalog-manager-secure"

/** API key for catalog-manager-secure prestation calls. */
const CATALOG_MANAGER_SECURE_API_KEY = "EYqj93IyuTaefOlYXfBYAClXMt8Rntr59vPev8G3"

/**
 * Normalize locale for Accept-Language header: underscores to hyphens;
 * en-US and en_US map to en-GB.
 * @param {string} locale
 * @returns {string}
 */
function normalizeAcceptLanguage(locale) {
    if (!locale || typeof locale !== "string") {
        return "fr-FR"
    }
    let normalized = locale.replace(/_/g, "-")
    if (normalized === "en-US" || normalized === "en-us") {
        return "en-GB"
    }
    return normalized
}

export default class CatalogService extends Service {
    constructor() {
        super()
        this.serviceUrl = `https://api.travelski.com/catalog`
        this.mandatoryFields = {
            "getStationData": ['stationId', 'locale']
        }
    }


    async getStationData(requestData) {
        this.checkMandatoryFields(requestData, "getStationData")
        const {stationId, locale} = requestData
        const headers = {}
        const params = {locale}
        const url = `${this.serviceUrl}/place/station/${stationId}`
        const {data} = await this.axios.get(url, {params, headers})
        return data
    }

    async getPrestationByLocale(requestData) {
        this.checkMandatoryFields(requestData, "getPrestationByLocale")
        const {prestationId, locale} = requestData
        const acceptLanguage = normalizeAcceptLanguage(locale)
        const headers = {
            "Accept-Language": acceptLanguage,
            "X-Api-Key": CATALOG_MANAGER_SECURE_API_KEY
        }
        const url = `${CATALOG_MANAGER_SECURE_URL}/secure/prestation/${prestationId}/retro`
        const {data} = await this.axios.get(url, {headers})
        return data?.message?.prestation ?? data
    }
}
